import {Component, Input, OnInit} from "@angular/core";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {IsfSaBillList} from "./isf.sa.bill.list";
import {
	NgbAccordionBody,
	NgbAccordionButton,
	NgbAccordionCollapse,
	NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem
} from "@ng-bootstrap/ng-bootstrap";
import {SAStatusBadge} from "./isf.sa.status";
import {BillData} from "../../shipper";


@Component({
	selector: 'bill-status-accordion',
	standalone: true,
	imports: [
		DatePipe,
		IsfSaBillList,
		NgForOf,
		NgbAccordionBody,
		NgbAccordionButton,
		NgbAccordionCollapse,
		NgbAccordionDirective,
		NgbAccordionHeader,
		NgbAccordionItem,
		SAStatusBadge,
		NgIf
	],
	template: `
        <div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true" [destroyOnHide]="false">

            <div ngbAccordionItem="{{b.billNumber}}" *ngFor="let b of bills" [collapsed]="bills.length == 0">

                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>
                        <div class="input-group">
                            <sa-status [status]="b.code" class="me-2"></sa-status>
                            <span class="me-2">{{ b.billNumber }}</span>
                            <span class="me-2 small">{{ b.dateTime | date:'medium' }}</span>
                        </div>
						<div class="input-group" *ngIf="b.containers.length > 0">
							<span class="me-1 small text-secondary">Containers:</span>
							<span class="me-1 small text-secondary" *ngFor="let c of b.containers">{{c.containerNumber}}</span>
						</div>
                    </button>
                </h2>

                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <sa-bill-list [billStatus]="b.billStatus"></sa-bill-list>
                        </ng-template>
                    </div>
                </div>

            </div>
        </div>
	`,
	styles:[`
        .accordion {
            --bs-accordion-active-bg: #32363d;
            /* --bs-accordion-active-color: #41464d; */
        }


        .accordion-button:focus {
            box-shadow: none;
        }
	`]
})
export class IsfBillStatusAccordion implements OnInit{
	
	@Input()
	bills:Array<BillData> = [];
	
	
	ngOnInit(): void {
		this.bills.forEach((b) => {
			b.billStatus  = b.billStatus.sort((a,b) => {
				if(new Date(a.dateTime).getTime() > new Date(b.dateTime).getTime()){return -1;}
				if(new Date(a.dateTime).getTime() < new Date(b.dateTime).getTime()){return 1;}
				return 0 ;
			})
		});
	}
}
